export default "__VITE_ASSET__BpLplgG6__"